import moment from "moment";
import { useEffect, useState } from "react";
import { API_URL, REACT_APP_SITE_KEY } from "../../config/app-config";
import calendar from "../../img/calendar.png";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import { FiArrowRight, FiDownload, FiLock, FiCalendar, FiClock, FiZap } from "react-icons/fi";
import { FaStar, FaInstagram, FaYoutube, FaGlobe, FaLinkedin, FaFacebook } from "react-icons/fa";

import "./ServiceCardThemeV8.css";

moment.locale("en");

// Calendar Component
function MonthGridCalendar({ slots, packageDays, selectedValue, onSelect }) {
  const today = moment().locale("en");
  const [viewMonth, setViewMonth] = useState(today.clone().startOf("month"));

  const availableSet = new Set((slots || []).filter((s) => s.available).map((s) => s.value));
  const slotMap = {};
  (slots || []).forEach((s) => { slotMap[s.value] = s; });

  const goMonth = (dir) => setViewMonth((prev) => prev.clone().locale("en").add(dir, "month").startOf("month"));
  
  const vmEn = viewMonth.clone().locale("en");
  const startDay = vmEn.clone().startOf("month").day();
  const daysInMonth = vmEn.daysInMonth();

  const cells = [];
  for (let i = 0; i < startDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  const weeks = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));

  const DOW = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  const isPrevDisabled = viewMonth.clone().locale("en").isSameOrBefore(today.clone().startOf("month"));

  return (
    <div>
      <div className="monthNavRow" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <button type="button" onClick={() => goMonth(-1)} disabled={isPrevDisabled} style={{ background: 'none', border: 'none', cursor: isPrevDisabled ? 'not-allowed' : 'pointer', fontSize: '18px', color: 'var(--v8-dark)' }}>‹</button>
        <h4 style={{ margin: 0, fontSize: '14px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.1em' }}>{vmEn.format("MMMM YYYY")}</h4>
        <button type="button" onClick={() => goMonth(1)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', color: 'var(--v8-dark)' }}>›</button>
      </div>
      <table className="monthGridCalendar" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
        <thead>
          <tr>{DOW.map((d) => (<th key={d} style={{ padding: '8px 0', fontSize: '12px', opacity: 0.7 }}>{d}</th>))}</tr>
        </thead>
        <tbody>
          {weeks.map((week, wi) => (
            <tr key={wi}>
              {week.map((day, di) => {
                if (!day) return <td key={di}><div style={{ padding: '8px' }}></div></td>;
                const dateVal = vmEn.clone().date(day).format("YYYY/MM/DD");
                const isPast = vmEn.clone().date(day).isBefore(today, "day");
                const dayMatches = packageDays.length === 0 || packageDays.includes(moment(dateVal, "YYYY/MM/DD").locale("en").format("ddd").toUpperCase());
                const isAvail = availableSet.has(dateVal) && !isPast && dayMatches;
                const isSelected = selectedValue === dateVal;
                
                let btnClass = "gridDayBtn ";
                if(isSelected) btnClass += "gridSelected";
                else if(isAvail) btnClass += "gridAvailable";
                
                return (
                  <td key={di} style={{ padding: '4px' }}>
                    <button
                      type="button"
                      className={btnClass}
                      style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', cursor: isAvail ? 'pointer' : 'not-allowed', opacity: isAvail || isSelected ? 1 : 0.3 }}
                      onClick={(e) => {
                        e.preventDefault();
                        if (!isAvail) return;
                        const slotObj = slotMap[dateVal];
                        if (slotObj) onSelect(slotObj);
                      }}
                    >
                      {day}
                    </button>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// Time Panel Component
function TimeSidePanel({ hasDateSelected, slots, selectedSlot, onSelect, isDisabledFn }) {
  return (
    <div className="timeSide">
      <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '16px', fontWeight: 800 }}>
        <FiClock size={14} style={{ marginRight: '6px', verticalAlign: 'text-bottom' }} />
        Select Time
      </div>
      {!hasDateSelected ? (
        <div style={{ opacity: 0.5, fontSize: '13px', fontWeight: 600 }}>Pick a date to see times</div>
      ) : (
        <div className="v8-twoColSlots">
          {slots.length > 0 ? (
            slots.map((item, i) => {
              const fromStr = item.from ?? "";
              const toStr = item.to ?? "";
              const fmt = fromStr.includes("AM") || fromStr.includes("PM") ? "hh:mm A" : "HH:mm";
              const displayFrom = moment(fromStr, fmt).isValid() ? moment(fromStr, fmt).format("h:mm A") : fromStr;
              const displayTo = moment(toStr, fmt).isValid() ? moment(toStr, fmt).format("h:mm A") : toStr;
              const isSelected = selectedSlot?.from === fromStr && selectedSlot?.to === toStr;
              const isDisabled = isDisabledFn ? isDisabledFn(item) : false;
              
              return (
                <button
                  type="button"
                  key={i}
                  className={`timeSlotBtn ${isSelected ? 'tsActive' : ''}`}
                  style={{ padding: '12px', fontSize: '13px', cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.5 : 1 }}
                  onClick={(e) => { e.preventDefault(); if (!isDisabled) onSelect(item); }}
                >
                  {displayFrom} – {displayTo}
                </button>
              );
            })
          ) : (
            <p style={{ gridColumn: '1/-1', fontSize: '13px', opacity: 0.7, fontWeight: 600 }}>No slots available</p>
          )}
        </div>
      )}
    </div>
  );
}

// Main Component
const ServiceCardThemeV8 = ({
  data,
  selectService,
  isPreview,
  uploadDetails,
  updateState,
  confirmDetails,
  recaptcha,
  viewAvailableSlot,
  slugSelected,
  onResourceClick,
}) => {
  
  const eventData = data.eventData || data.eventDetails || {};
  const userDetails = data.userDetails || {};
  const resourceList = data.resource || data.resourceList || [];
  
  const businessLogo = isPreview 
    ? eventData.businessLogo 
    : eventData.businessLogo ? `${API_URL}auth/image/${eventData.businessLogo}` : calendar;
    
  const businessName = eventData.businessName || userDetails.userName || "Rohan Khanna";
  
  // Use sliderTextOne for the Hero Title as requested
  const defaultTitle = "TRAIN IN THE CITY.";
  const displayTitle = eventData.sliderTextOne || defaultTitle;

  const renderHeroTitle = (title) => {
    if (title.toUpperCase() === defaultTitle.toUpperCase()) {
      return <>TRAIN<br/>IN THE<br/><span className="v8-accent">CITY.</span></>;
    }
    const words = title.split(' ');
    return words.map((w, i) => (
      <span key={i}>
        {i === words.length - 1 ? <span className="v8-accent">{w}</span> : w}
        <br/>
      </span>
    ));
  };

  const rawReviews = data.reviewList || [];
  const dummyReviews = [
    { name: "Simran J.", source: "Google", suggestion: "A training plan with structure, without losing the fun.", satisfaction: 5, updateDate: Date.now() },
    { name: "Karthik A.", source: "Google", suggestion: "The rare class that feels both hard and welcoming.", satisfaction: 5, updateDate: Date.now() - 86400000 },
    { name: "Neha P.", source: "Google", suggestion: "Recovery finally feels like part of my progress.", satisfaction: 5, updateDate: Date.now() - 172800000 }
  ];
  const reviews = rawReviews.length > 0 ? rawReviews : dummyReviews;
  const avgRating = eventData.ratings ?? "4.9/5";

  const dummyServices = [
    { serviceName: "Tuesday / Full body", duration: 60, amount: 900, appointmentName: "INDIVIDUAL COACHING", description: "A tailored session with clear movement cues and progression.", timeLabel: "6:30 PM" },
    { serviceName: "Thursday / Engine", duration: 60, amount: 900, appointmentName: "SMALL GROUP CLASS", description: "Train alongside a close cohort while keeping coaching specific.", timeLabel: "6:30 PM" },
    { serviceName: "Saturday / Club run", duration: 90, amount: 650, appointmentName: "INDIVIDUAL COACHING", description: "A detailed session for strength, recovery and a sustainable plan.", timeLabel: "7:00 AM" }
  ];
  const rawServiceList = data.service || data.serviceList || [];
  const serviceList = rawServiceList.length > 0 ? rawServiceList : dummyServices;

  const [chosenService, setChosenService] = useState(null);
  const [isPackageSelected, setIsPackageSelected] = useState({});
  const [reviewIndex, setReviewIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedNoteOption, setSelectedNoteOption] = useState(""); // Track the dropdown selection
  const isMobile = window.screen.width < 768;

  useEffect(() => {
    if (!slugSelected || !serviceList.length) return;
    const index = serviceList.findIndex((s) => s.slug === slugSelected || String(s.id) === String(slugSelected));
    if (index !== -1) handleBookClick(serviceList[index], index);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slugSelected, serviceList]);

  // FIX 2: close the modal automatically once a booking completes.
  // The free-booking flow never toggled isModalOpen (it's local state here),
  // so the modal stayed open after a free booking succeeded. The parent
  // (CalendarVcard) flips data.bookingSuccess to true on both the free and
  // paid success paths — this effect reacts to that signal.
  useEffect(() => {
    if (data.bookingSuccess) {
      setIsModalOpen(false);
    }
  }, [data.bookingSuccess]);

  const safeParse = (value) => {
    try {
      if (!value) return [];
      const p = JSON.parse(value);
      return typeof p === "string" ? JSON.parse(p) : p;
    } catch (e) { return []; }
  };

  const packageDays = safeParse(isPackageSelected?.packageDays);
  const timeSlots = safeParse(isPackageSelected?.timeSlots) || [];

  const getAllSlots = () => {
    if (!data.availableSlot?.length) return [];
    return data.availableSlot.filter((item) => {
      if (Object.keys(data?.activeIndexData || {}).length > 0) {
        const isToday = moment(data.activeIndexData.value, "YYYY/MM/DD");
        if (isToday.isSame(moment(), "day")) {
          const curTime = moment(new Date(), "HH:mm");
          const fromTime = moment(item.from, "HH:mm");
          return fromTime.isSameOrAfter(curTime);
        }
      }
      return true;
    });
  };

  const priceLabel = (svc) => (svc?.amount == 0 ? "Free" : `₹${svc?.amount}`);
  const selectedServiceObj = chosenService !== null ? serviceList[chosenService] : null;

  const handleBookClick = (item, ind) => {
    selectService(item);
    setChosenService(ind);
    setIsPackageSelected(item);
    updateState("bookingMode", "self");
    updateState("expertNote", "");
    updateState("bookingSuccess", false); // FIX 2: clear any stale success flag from a previous booking
    setIsModalOpen(true);
  };

  const handleResourceCardClick = (res) => {
    if (isPreview) return;
    if (typeof onResourceClick === "function") onResourceClick(res);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    updateState("name", "");
    updateState("email", "");
    updateState("phoneNumber", "");
    updateState("description", "");
    updateState("detailsPage", false); // Reset back to step 1
    updateState("bookingSuccess", false); // FIX 2: keep state clean on manual close too
    setSelectedNoteOption(""); // Reset dropdown selection

    if (recaptcha?.current) {
      recaptcha.current.reset();
    }
  };

  const handleNextReview = () => setReviewIndex((prev) => (prev + 1) % reviews.length);
  const handlePrevReview = () => setReviewIndex((prev) => (prev - 1 + reviews.length) % reviews.length);

  // Stepper Indicator
  const renderStepper = (activeStep) => (
    <div className="v8-bkStepBar">
      <div className={`v8-bkStep ${activeStep === 1 ? "active" : activeStep > 1 ? "done" : ""}`}>
        <div className="v8-bkStepCircle">{activeStep > 1 ? "✓" : "1"}</div>
        <span>Choose option</span>
      </div>
      <div className={`v8-bkStepLine ${activeStep > 1 ? "done" : ""}`} />
      <div className={`v8-bkStep ${activeStep === 2 ? "active" : activeStep > 2 ? "done" : ""}`}>
        <div className="v8-bkStepCircle">{activeStep > 2 ? "✓" : "2"}</div>
        <span>Provide details</span>
      </div>
      <div className={`v8-bkStepLine ${activeStep > 2 ? "done" : ""}`} />
      <div className={`v8-bkStep ${activeStep === 3 ? "active" : ""}`}>
        <div className="v8-bkStepCircle">3</div>
        <span>Confirmation</span>
      </div>
    </div>
  );

  // Modal Booking Flow
  const renderBookingModal = () => {
    if (!isModalOpen || chosenService === null) return null;
    const isGroupPackage = ["group_package", "one_to_one_package"].includes(isPackageSelected?.appointmentName);
    
    return (
      <div className="v8-modal-overlay" onClick={closeModal}>
        <div className="v8-modal-content" onClick={(e) => e.stopPropagation()}>
          <button type="button" className="v8-modal-close" onClick={closeModal}>×</button>
          
          {data.detailsPage ? (
            <form onSubmit={(e) => { e.preventDefault(); uploadDetails(e); }} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {renderStepper(2)}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px' }}>
                <h4 style={{ margin: 0, fontSize: '24px', fontWeight: 800, textTransform: 'uppercase' }}>Provide Details</h4>
                <button type="button" onClick={() => { recaptcha?.current?.reset(); updateState("detailsPage", false); }} className="v8-btn-outline" style={{ border: 'none' }}>
                  ← Back to options
                </button>
              </div>
              
              <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:800, textTransform:'uppercase' }}>Name *</label>
                <input className="input-text-input" value={data.name} type="text" placeholder="ENTER NAME" required onChange={(e) => updateState("name", e.target.value)} />
              </div>
              <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:800, textTransform:'uppercase' }}>Email *</label>
                <input className="input-text-input" value={data.email} type="email" placeholder="ENTER EMAIL" required onChange={(e) => updateState("email", e.target.value?.trim())} />
              </div>
                 <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:600 }}>Phone Number *</label>
                <div style={{ marginTop: "4px" }}>
                  <PhoneInput
                    country={"in"}
                    containerClass="input-dark"
                    value={data.phoneNumber}
                    placeholder=""
                    countryCodeEditable={false}
                    onChange={(phone) => updateState("phoneNumber", phone)}
                    required
                  />
                </div>
              </div>
                 <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:600 }}>Notes for preparation *</label>
                <select 
                  className="input-text-input" 
                  value={selectedNoteOption}
                  required
                  onChange={(e) => {
                    setSelectedNoteOption(e.target.value);
                    if (e.target.value !== "Other") {
                      updateState("description", e.target.value);
                    } else {
                      updateState("description", "");
                    }
                  }}
                  style={{ marginBottom: selectedNoteOption === "Other" ? '12px' : '0' }}
                >
                  <option value="" disabled>Select an option</option>
                  <option value="I'm looking for general relaxation and mindfulness.">I'm looking for general relaxation and mindfulness.</option>
                  <option value="I'm dealing with specific tension/tightness and need relief.">I'm dealing with specific tension/tightness and need relief.</option>
                  <option value="I'm a beginner looking for a gentle introduction.">I'm a beginner looking for a gentle introduction.</option>
                  <option value="Other">Other (I will type my own notes)</option>
                </select>

                {selectedNoteOption === "Other" && (
                  <textarea 
                    className="input-text-input" 
                    value={data.description} 
                    required={selectedNoteOption === "Other"} 
                    placeholder="Please specify your requirements or notes here..."
                    onChange={(e) => updateState("description", e.target.value)} 
                    style={{ minHeight: '100px', resize: 'vertical' }} 
                  />
                )}
              </div>
              
              <div style={{ margin: "8px 0" }}>
                <ReCAPTCHA size={isMobile ? "compact" : "normal"} ref={recaptcha} sitekey={REACT_APP_SITE_KEY} />
              </div>
              
              <button type="submit" className="v8-btn-primary" onClick={() => confirmDetails()} style={{ alignSelf: 'flex-start' }}>
                <FiCalendar size={16}/> Book {selectedServiceObj?.serviceName} - {priceLabel(selectedServiceObj)} <FiArrowRight size={16} />
              </button>
            </form>
          ) : (
            <div>
              {renderStepper(1)}
              
              {!isGroupPackage && (
                <>
                  <div style={{ marginBottom: '32px', textAlign: 'center' }}>
                    <h2 style={{ fontSize: '32px', fontWeight: 900, textTransform: 'uppercase', marginBottom: '8px' }}>
                      Schedule your session
                    </h2>
                    <p style={{ opacity: 0.6, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', fontSize: '13px' }}>
                      Choose how you&apos;d like to book
                    </p>
                  </div>
                  
                  <div className="v8-bkModeRow">
                    <div className={`v8-bkModeCard ${data.bookingMode === "self" ? "bkSelected" : ""}`} onClick={() => updateState("bookingMode", "self")}>
                      <div className="v8-bkModeRadio">{data.bookingMode === "self" && <div className="v8-bkModeRadioInner" />}</div>
                      <div className="v8-bkModeText">
                        <h5>I&apos;ll pick date & time</h5>
                        <p>Select from available slots</p>
                      </div>
                    </div>
                    
                    <div className={`v8-bkModeCard ${data.bookingMode === "expert" ? "bkSelected" : ""}`} onClick={() => updateState("bookingMode", "expert")}>
                      <div className="v8-bkModeRadio">{data.bookingMode === "expert" && <div className="v8-bkModeRadioInner" />}</div>
                      <div className="v8-bkModeText">
                        <h5>Let the expert choose</h5>
                        <p>Share your preference and expert will schedule</p>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {data.bookingMode === "expert" && !isGroupPackage && (
                <div style={{ padding: '32px', background: '#fff', border: '1px solid var(--v8-dark)', marginBottom: '32px' }}>
                  <label style={{ display:'block', marginBottom:'16px', fontSize:'14px', fontWeight:800, textTransform: 'uppercase' }}>Share your preference / availability</label>
                  <textarea 
                    className="input-text-input"
                    placeholder="e.g. I'm available weekday evenings after 6 PM IST, prefer Thursday or Friday..."
                    value={data.expertNote || ""}
                    onChange={(e) => updateState("expertNote", e.target.value)}
                    style={{ minHeight: '120px', marginBottom: '16px' }}
                  />
                  <p style={{ fontSize: '13px', opacity: 0.7, fontWeight: 600 }}>The expert will review your preference and send you a confirmed slot via email.</p>
                </div>
              )}

              {(data.bookingMode === "self" || isGroupPackage) && (
                <div className="v8-calTimeSplit">
                  <div className="v8-calSide">
                    <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '16px', fontWeight: 800 }}>
                      <FiCalendar size={14} style={{ marginRight: '6px', verticalAlign: 'text-bottom' }} />
                      Select Date
                    </div>
                    <MonthGridCalendar
                      slots={data.slots}
                      packageDays={isGroupPackage ? packageDays : []}
                      selectedValue={data.activeIndexData?.value}
                      onSelect={(slotObj) => {
                        const idx = data.slots?.findIndex((s) => s.value === slotObj.value);
                        viewAvailableSlot(idx ?? 0, slotObj, slotObj.available);
                      }}
                    />
                  </div>
                  
                  <div className="v8-timeSide">
                    {data.activeIndexData?.value && (
                      <div className="v8-tzChip">
                        <FiClock size={14} /> {eventData.timeZone ? `Times in ${eventData.timeZone}` : "Times in IST"}
                      </div>
                    )}
                    
                    {!data.activeIndexData?.value ? (
                      <div style={{ padding: '60px 20px', textAlign: 'center', opacity: 0.4, border: '1px solid var(--v8-border)', background: '#fff' }}>
                        <FiCalendar size={40} style={{ marginBottom: '16px' }} />
                        <p style={{ fontSize: '13px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em' }}>No date selected<br/><span style={{ opacity: 0.7, fontWeight: 500, fontSize: '12px' }}>Pick a date on the left</span></p>
                      </div>
                    ) : (
                      <div className="v8-twoColSlots">
                        {(isGroupPackage ? timeSlots : getAllSlots()).length > 0 ? (
                          (isGroupPackage ? timeSlots : getAllSlots()).map((item, i) => {
                            const fromStr = item.from ?? "";
                            const toStr = item.to ?? "";
                            const fmt = fromStr.includes("AM") || fromStr.includes("PM") ? "hh:mm A" : "HH:mm";
                            const displayFrom = moment(fromStr, fmt).isValid() ? moment(fromStr, fmt).format("h:mm A") : fromStr;
                            const displayTo = moment(toStr, fmt).isValid() ? moment(toStr, fmt).format("h:mm A") : toStr;
                            const isSelected = data.selectedSlot?.from === fromStr && data.selectedSlot?.to === toStr;
                            const isDisabled = item.slotAvailable === false;
                            
                            return (
                              <button
                                type="button"
                                key={i}
                                className={`timeSlotBtn ${isSelected ? 'tsActive' : ''}`}
                                style={{ padding: '14px', fontSize: '13px', cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.5 : 1 }}
                                onClick={(e) => { 
                                  e.preventDefault(); 
                                  if (!isDisabled) {
                                    updateState("slotActiveIndex", isGroupPackage ? i : getAllSlots().findIndex(s => s.from === item.from));
                                    updateState("selectedSlot", item);
                                  } 
                                }}
                              >
                                {displayFrom} – {displayTo}
                              </button>
                            );
                          })
                        ) : (
                          <p style={{ gridColumn: '1/-1', fontSize: '13px', opacity: 0.7, fontWeight: 700, textTransform: 'uppercase' }}>No slots available</p>
                        )}
                      </div>
                    )}

                    {!isGroupPackage && data.activeIndexData?.value && (
                       <div style={{ display: 'flex', gap: '16px', padding: '24px', background: '#fff', border: '1px solid var(--v8-border)', marginTop: '24px' }}>
                         <FiZap size={20} color="var(--v8-red)" style={{ flexShrink: 0 }} />
                         <div>
                           <h6 style={{ fontSize: '14px', fontWeight: 800, marginBottom: '8px', textTransform: 'uppercase' }}>Instant confirmation</h6>
                           <p style={{ fontSize: '13px', opacity: 0.7, lineHeight: 1.5, fontWeight: 500 }}>Your session will be confirmed immediately after booking.</p>
                         </div>
                       </div>
                    )}
                  </div>
                </div>
              )}

              <div style={{ marginTop: '48px', display: 'flex', justifyContent: 'center' }}>
                <button 
                   type="button" 
                   className="v8-btn-primary" 
                   style={{ width: '100%', maxWidth: '400px', justifyContent: 'center' }}
                   onClick={() => isPreview ? () => {} : confirmDetails()}
                >
                  Continue to Details <FiArrowRight size={18} />
                </button>
              </div>

            </div>
          )}
        </div>
      </div>
    );
  };

  const currentReview = reviews[reviewIndex] || reviews[0];

  return (
    <div className="v8-wrapper">
      <div className="v8-container">
        
        {/* Ticker Bar */}
        <div className="v8-ticker">
          SWEAT · SKILL · STRONGER · SWEAT · SKILL · STRONGER · SWEAT · SKILL · STRONGER · SWEAT · SKILL · STRONGER
        </div>

        {/* Header */}
        <header className="v8-header">
          <div className="v8-logo-group">
            <span className="v8-logo-circle">
               {businessLogo && businessLogo !== calendar ? (
                 <img src={businessLogo} alt="Logo" />
               ) : (
                 "RK"
               )}
            </span>
            {/* Displaying Service Name here */}
            <span>{eventData.serviceName || "CONCRETE CLUB"}</span>
          </div>
          <div style={{ fontSize: '12px', fontWeight: 700, textTransform: 'uppercase' }}>
            Training with {businessName.split(' ')[0]}
          </div>
        </header>

        {/* Hero Section */}
        <section className="v8-hero">
          <div className="v8-hero-content">
            <h1 className="v8-hero-title">
              {renderHeroTitle(displayTitle)}
            </h1>
            <div className="v8-hero-desc" dangerouslySetInnerHTML={{__html: eventData.description || "Small-group strength sessions for people who like their training direct, social and seriously good." }} />
            
            {/* FIX 1: scrollIntoView instead of offsetTop-based scrollTo — offsetTop
                is relative to the nearest positioned ancestor, not the page, so any
                positioned ancestor in the tree (e.g. the modal overlay) makes it
                resolve to 0 or the wrong offset. scrollIntoView always targets the
                real element regardless of ancestor positioning. */}
            <button
              type="button"
              className="v8-btn-primary"
              onClick={() =>
                document
                  .querySelector('#services-section')
                  ?.scrollIntoView({ behavior: 'smooth', block: 'start' })
              }
            >
              View Services
            </button>
          </div>
          
          <div className="v8-hero-visual">
            {businessLogo && businessLogo !== calendar ? (
               <div className="v8-hero-image" style={{ backgroundImage: `url(${businessLogo})` }}></div>
            ) : (
               <div className="v8-hero-image" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=600')` }}></div>
            )}
          </div>
        </section>

        {/* Red Divider Line */}
        <div className="v8-red-bar"></div>

        {/* Services Split Section ("THIS WEEK") */}
        <section className="v8-services-split" id="services-section">
          <div className="v8-services-left">
            <h2 className="v8-section-title">This Week</h2>
            
            <div className="v8-services-list">
              {serviceList.map((item, ind) => {
                return (
                  <div key={ind} className="v8-service-item">
                    <div className="v8-service-header">
                      <div className="v8-service-name">{item.serviceName}</div>
                      <div className="v8-service-price">
                        {item.timeLabel ? `${item.timeLabel} · ` : `${item.duration} min · `}{priceLabel(item)}
                      </div>
                    </div>
                    <div className="v8-service-type">
                      {item.appointmentName?.replace(/_/g, ' ').toUpperCase() || "INDIVIDUAL COACHING"}
                    </div>
                    <p className="v8-service-desc">{item.description}</p>
                    <button type="button" className="v8-btn-outline" onClick={() => handleBookClick(item, ind)}>
                      {item.btnText || "Book this session →"}
                    </button>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="v8-services-right">
            <div className="v8-member-eyebrow">Member Note · ★★★★★</div>
            <div className="v8-member-quote">
              “{reviews[1]?.suggestion && reviews[1].suggestion !== "Not given" ? reviews[1].suggestion : "The rare class that feels both hard and welcoming."}”
            </div>
            <div className="v8-member-author">
              — {reviews[1]?.name || "Karthik A."} · {reviews[1]?.source || "Google"}
            </div>
          </div>
        </section>

        {/* Client Notes Section */}
        <section className="v8-notes-section">
          <div className="v8-notes-box">
            <div className="v8-notes-header">
              <div>
                <h4>Client Notes</h4>
                <h2>What clients say about {businessName}</h2>
              </div>
              <div style={{ fontSize: '13px', fontWeight: 800 }}>★★★★★ · {avgRating}</div>
            </div>
            
            <div className="v8-notes-content">
              <blockquote>
                “{currentReview?.suggestion && currentReview.suggestion !== "Not given" 
                  ? currentReview.suggestion 
                  : "A training plan with structure, without losing the fun."}”
              </blockquote>
              
              <div style={{ fontSize: '13px', marginBottom: '40px', opacity: 0.8, display: 'flex', alignItems: 'center' }}>
                {Array.from({ length: Math.round(currentReview?.satisfaction || 5) }).map((_, i) => (
                   <FaStar key={i} size={13} color="var(--v8-dark)" style={{ marginRight: '2px' }} />
                ))}
                &nbsp;· {currentReview?.name || "Simran J."} · {currentReview?.source || "Google"}
              </div>
              
              <div className="v8-notes-controls">
                <div>
                  <button type="button" className="v8-arrow-btn" onClick={handlePrevReview}>←</button>
                  <button type="button" className="v8-arrow-btn" onClick={handleNextReview}>→</button>
                </div>
                <div style={{ fontSize: '12px', opacity: 0.6, letterSpacing: '0.1em', fontWeight: 700 }}>
                  {reviews.length > 0 ? `${reviewIndex + 1} / ${reviews.length}` : "1 / 3"}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Ready-Made Resources Section */}
        {resourceList.length > 0 && (
          <section className="v8-resources-section" id="resources-section">
            <h2 className="v8-section-title" style={{ marginBottom: '32px' }}>Digital Resources</h2>
            <div className="v8-resources-grid">
              {resourceList.map((res, ind) => {
                const isResourceFree = Number(res.amount) === 0;
                const fileCount = res.resourceFiles?.length || 0;
                
                return (
                  <div key={res.id} className="v8-resource-card" onClick={() => handleResourceCardClick(res)} style={{ cursor: 'pointer' }}>
                    <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '8px', fontWeight: 800, color: 'var(--v8-red)' }}>
                      RESOURCE {ind + 1} {fileCount > 0 && `· ${fileCount} FILE${fileCount !== 1 ? 'S' : ''}`}
                    </div>
                    <h3 style={{ fontSize: '20px', fontWeight: 800, marginBottom: '8px' }}>{res.serviceName}</h3>
                    <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '16px' }}>
                      {isResourceFree ? "Free" : `₹${res.amount}`}
                    </div>
                    <p style={{ fontSize: '13px', lineHeight: 1.5, opacity: 0.8, flex: 1, marginBottom: '24px' }}>{res.description}</p>
                    <button 
                      type="button"
                      className="v8-btn-outline" 
                      style={{ width: 'fit-content' }}
                      onClick={(e) => { e.stopPropagation(); handleResourceCardClick(res); }}
                    >
                      {isResourceFree ? (
                        <>Download <FiDownload size={14} /></>
                      ) : (
                        <>Purchase <FiLock size={12} /></>
                      )}
                    </button>
                  </div>
                );
              })}
            </div>
          </section>
        )}

        {/* About Provider */}
        <section className="v8-about-section">
          <h4>Meet Your Provider</h4>
          
          {/* Render Professional Name */}
          <h3>{userDetails.userName || businessName}</h3>
          
          {/* Render Profession Details */}
          <p>{userDetails.profession?.professionName || "Rohan runs direct, social training sessions built for the pace of city life."}</p>
          
          {/* Render Social Media Accounts */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginTop: '20px', marginBottom: '32px' }}>
            {userDetails.youtube && (
              <a href={userDetails.youtube} target="_blank" rel="noreferrer" style={{ color: 'var(--v8-red)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 700 }}>
                <FaYoutube size={16} /> YouTube
              </a>
            )}
            
            {userDetails.instagram && (
              <a href={userDetails.instagram} target="_blank" rel="noreferrer" style={{ color: 'var(--v8-red)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 700 }}>
                <FaInstagram size={16} /> Instagram
              </a>
            )}
            
            {userDetails.personalWebsite && (
              <a href={userDetails.personalWebsite} target="_blank" rel="noreferrer" style={{ color: 'var(--v8-red)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 700 }}>
                <FaGlobe size={16} /> Website
              </a>
            )}

            {userDetails.faceBook && (
              <a href={userDetails.faceBook} target="_blank" rel="noreferrer" style={{ color: 'var(--v8-red)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 700 }}>
                <FaFacebook size={16} /> Facebook
              </a>
            )}

            {userDetails.linkedIn && (
              <a href={userDetails.linkedIn} target="_blank" rel="noreferrer" style={{ color: 'var(--v8-red)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 700 }}>
                <FaLinkedin size={16} /> LinkedIn
              </a>
            )}
          </div>

          {/* Render Specialisations */}
          {eventData.specialisations && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', maxWidth: '500px' }}>
               {eventData.specialisations.split(',').map((spec, i) => (
                  <span key={i} style={{ border: '1px solid var(--v8-border)', padding: '6px 12px', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase' }}>{spec.trim()}</span>
               ))}
            </div>
          )}

          <div style={{ marginTop: '48px' }}>
            <svg width="120" height="30" viewBox="0 0 120 30" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M12.5 5 C10 12 15 20 18 20 C18 10 15 5 12.5 5 Z" fill="#e91e63" />
               <path d="M22 5 C24.5 12 19 20 16 20 C16 10 19 5 22 5 Z" fill="#e91e63" opacity="0.8" />
               <text x="32" y="21" fontFamily="Inter" fontWeight="800" fontSize="18" fill="var(--v8-dark)">Yuukke</text>
            </svg>
          </div>
        </section>
        
        {/* Render Booking Modal */}
        {renderBookingModal()}
      </div>
    </div>
  );
};

export default ServiceCardThemeV8;